import BaseComponent from "../../../base/base_component";
import FPVouchersComponentModel from "./fp_vouchers_component_model";
import _ from "../../../utils/underscore";
import VoucherComponentController from "../voucher/free_play_voucher_component_controller";
import DOM from "../../../utils/dom";
import ScrollableContainer from "../../scrollable_container/scrollable_container_controller";
import { IAlteredFreePlayVoucher } from "../voucher/free_play_voucher_consts";
import {IFreePlayVoucherData} from "../../../../../common/interfaces/free-play/free-play-voucher-data.interface";

const vouchersView = require('./view/fp_vouchers_component.html');

export default class FPVouchersComponentController extends BaseComponent {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'FPVouchersComponentController';


    /**
     * @static
     * @type {string}
     */
    static DIRECTIVE = 'cgp-directive-vouchers_list';

    _model: FPVouchersComponentModel;

    _selector = 'cgp-free-play-vouchers-list-component';

    private _vouchersContainer: ScrollableContainer;


    init(params) {
        super.init(params);
        this._model = FPVouchersComponentModel.create(params);
    }


    start() {
        const voucherHtml = this.bake(vouchersView, {
            voucherTitle: this._model.getTitle()
        });
        this.setHTML(voucherHtml);
        return this;
    }


    /**
     * Handle event when the component attached to DOM.
     * From this point the component is ready to execute DOM manipulation and calculations regarding to entire document
     */
    onAppendedToDOM() {
        super.onAppendedToDOM();
        //this._subscribeUserEvents();
        //this._assignMessageHeight();
        return this._injectVouchersList();
    }


    scrollToVoucher(index) {
        // TODO
    }


    onSizeChanged() {
        if (this._vouchersContainer) {
            this._vouchersContainer.onSizeChanged();
        }
    }


    /**
     * Get active vouchers
     * @returns {*}
     */
    getVouchers() {
        return this._model.getVouchers();
    }



    onVoucherExpired(voucherId) {
        this._model.getContainerRef().onVoucherExpired(voucherId);
    }



    /**
     * Handle voucher remove
     * @param voucherId
     * @private
     */
    removeVoucher(voucherId: string, animation: boolean) {
        const deleteIndex = this._getVoucherIndex(voucherId);
        if (-1 < deleteIndex) {
            const removedVoucher = this._model.getVouchers().splice(deleteIndex, 1)[0];
            removedVoucher.component.shutDown();
            return this._vouchersContainer.removeItem(deleteIndex, animation)
                .then((newIndex: number) => {
                    if (!_.isNullOrUndefined(newIndex)) {
                        return this._model.getVouchers()[newIndex];
                    } else {
                        return undefined;
                    }
                });
        } else {
            return Promise.reject();
        }
    }


    /**
     * Find voucher index in voucher array
     * @returns {*}
     * @private
     */
    _getVoucherIndex(voucherId) {
        const vouchers = this._model.getVouchers();
        if (!vouchers) {
            return;
        }
        let voucherIndex;
        vouchers.forEach((voucher, index) => {
            if (voucher.ID === voucherId) {
                voucherIndex = index;
            }
        });

        return voucherIndex;
    }

    /**
     * Try to get vouchers from model or service.
     * If vouchers exist, inject them to Element HTML, otherwise display no reward dialog
     * @private
     */
    _injectVouchersList() {
        return new Promise<void>((res, rej) => {
            this._getVouchers().then((voucherList: IFreePlayVoucherData[]) => {
                if (!_.isArray(voucherList) || 0 === voucherList.length) {
                    return rej();
                }
                const vouchersContainer = this.getDOMElementByClassName('cgp-fp-vouchers-container'); // TODO to consts
                voucherList.forEach((voucher: IAlteredFreePlayVoucher) => {
                    const voucherComponent = VoucherComponentController.create({voucher: voucher, container: this}).start();
                    voucher.component = voucherComponent;
                    DOM.addClass(voucherComponent.getEl(), 'cgp-fp-voucher-wrapper');
                });
                this._vouchersContainer = this._createScrollableContainer(voucherList.map((voucher: IAlteredFreePlayVoucher) => {
                    return voucher.component.getEl();
                }));
                DOM.append(vouchersContainer, this._vouchersContainer.getEl());
                this._vouchersContainer.onAppendedToDOM();
                this._vouchersContainer.onActiveChanged = (index) => {
                    this.onVoucherSelected(this._model.getVouchers()[index].ID, true);
                };
                res();
            });
        });

    }


    /**
     * Create ScrollableContainer for vouchers with device and direction configuration
     * @param vouchers
     * @private
     */
    _createScrollableContainer(items) {
        const instance = ScrollableContainer.create(Object.assign({}, {items: items}, this._model.getScrollingOptions()));
        instance.start();
        return instance;
    }



    /**
     * Get voucher from model. If vouchers don't exist, try to retrieve vouchers from Service and update the Model
     * @returns {*}
     * @private
     */
    _getVouchers() {
        const voucherList = this._model.getVouchers();
        if (!_.isArray(voucherList) || 0 === voucherList.length) {
            this.logger.debug('Vouchers list is empty, try to retrieve vouchers from FreePlayService');
            return this.serviceFactory.freePlayService().getFreePlayVouchers()
                .then((vouchers) => {
                    this._model.setVouchers(vouchers);
                    return vouchers;
                });
        }

        return Promise.resolve(voucherList);
    }


    /**
     * Open voucher games
     * @param voucherId
     */
    onVoucherSelected(voucherId: string, activeChanged = false) {
        this.logger.debug('Voucher ' + voucherId + ' is selected.');
        const voucher = this.getVoucherByVoucherID(voucherId);
        if (voucher) {
            this._model.getContainerRef().onVoucherSelected(voucher, activeChanged);
        }
    }




    /**
     * Find voucher by voucherID
     * @param voucherId
     * @returns {*}
     * @private
     */
    getVoucherByVoucherID(voucherId) {
        const voucherIndex = this._getVoucherIndex(voucherId);
        if (-1 < voucherIndex ) {
            return this._model.getVouchers()[voucherIndex];
        }
        return undefined;
    }


    /**
     * Send GA
     * @param action
     * @param label
     */
    sendAnalytics(action, params = {}) {
        this._model.getContainerRef().sendAnalytics(action, params);
    }


    shutDown() {
        super.shutDown();
        // remove vouchers
        // TODO
    }

}
